<div class="ag-cell-label-container">
  <span [hidden]="!params.enableMenu"
    class="ag-header-icon ag-header-cell-menu-button ag-header-menu-always-show"
    (click)="onMenuClick()">
    @if (!filterActive) {
      <rask-icon icon="fal fa-filter"></rask-icon>
    }
    @if (filterActive) {
      <rask-icon icon="fas fa-filter"></rask-icon>
    }
  </span>
  <div class="ag-header-cell-label" (click)="onSortRequested($event)">
    <span class="ag-header-cell-text">
      <span
        [ngbPopover]="template"
        [disablePopover]="!params.tooltipText"
        [openDelay]="300"
        [closeDelay]="300"
        triggers="mouseenter:mouseleave"
        container="body">
        {{params.displayName}}
      </span>
      @if (params.iconClass) {
        <rask-icon [icon]="params.iconClass" [text]="params.popoverMessage"></rask-icon>
      }
    </span>
    <span
      class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon"
      class="{{sortorder === 'asc' ? '' : 'ag-hidden'}}">
      <span class="ag-icon ag-icon-asc"></span>
    </span>
    <span
      class="ag-header-icon ag-header-label-icon ag-sort-descending-icon"
      class="{{sortorder === 'desc' ? '' : 'ag-hidden'}}">
      <span class="ag-icon ag-icon-desc"></span>
    </span>
  </div>
</div>

<ng-template #template>
  {{ params.tooltipText }}
  <ng-content></ng-content>
</ng-template>

<div #templateResult style="display: none">
  <ng-container *ngTemplateOutlet="template"></ng-container>
</div>
